function first_slider() {
     if (!$('.synapse-slider-products_images').hasClass('slick-initialized')) { }
      $(".synapse-slider-products_images").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        centerMode: false,
        infinite: false,
        prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0798/8389/4968/files/prev.svg?v=1753253392"></button>',
        nextArrow: '<button type="button" class="slick-next right_arrow"><img src="https://cdn.shopify.com/s/files/1/0798/8389/4968/files/next.svg?v=1753251685"></button>'
      });
  }
first_slider()
$(document).ready(function () {

  $('.collection_frames').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      arrows: true,
      centerMode: false,
      infinite: false,
      prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0798/8389/4968/files/left-arrow.svg?v=1744787171"></button>',
      nextArrow: '<button type="button" class="slick-next right_arrow"><img src="https://cdn.shopify.com/s/files/1/0798/8389/4968/files/left-arrow.svg?v=1744787171"></button>'
    });
  $('#addcart_popup_btn').on('click', function (e) {
    e.stopPropagation();
    $('.product_popup_main').addClass('active-popup');
    $('body').addClass('cart-popup-open');
    $('.collection_frames').slick('refresh');
    $('.synapse-slider-products_images').slick('refresh');
  
  });

let lineClampElement = $('.Right_side_Section .line-clamp-6');
let buttonTertiary = $('.Right_side_Section .button-tertiary');
function restoreElements() {
    lineClampElement.addClass('line-clamp-6');
    buttonTertiary.show(); // Ensure the button is visible again
}
$('.Right_side_Section .button-tertiary').on('click', function() {
    lineClampElement.removeClass('line-clamp-6');
    $(this).hide();
});
$('#product_popup button.close_box').on('click', function(e) {
    e.stopPropagation();
    $('.product_popup_main').removeClass('active-popup');
    $('body').removeClass('cart-popup-open'); 
    restoreElements();
});
$('.product_popup_main').on('click', function(e) {
    if (!$(e.target).closest('.Modal_popup').length) {
        $(this).removeClass('active-popup');
        $('body').removeClass('cart-popup-open'); 
        restoreElements();
    }
});
});


async function storeFront(handle) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("X-Shopify-Storefront-Access-Token", "f7600810af5f9756e29d8e5dbd812fe0");
  const graphql = JSON.stringify({
    query: `
      query {
        productByHandle(handle: "${handle}") {
          id
          title
          media(first: 10) {
            nodes {
              ... on MediaImage {
                image {
                  url
                  altText
                }
              }
            }
          }
          variants(first: 1) {
            nodes {
              price {
                amount
                currencyCode
              }
            }
          }
        border_frame_image:metafield(namespace:"custom",key:"border_frame_image"){
              reference {
        ... on MediaImage {
          image {
            url
            altText
          }
        }
      }
        }
        }
      }`,
    variables: {}
  });
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow"
  };
  try {
    const response = await fetch("https://fkycej-im.myshopify.com/api/2025-04/graphql.json", requestOptions);
    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error;
  }
}
document.querySelectorAll('.collection_frames li').forEach( items=>{
    items.addEventListener('click',async function (e) {
    document.querySelectorAll('.collection_frames li').forEach(el => el.classList.remove('active'));
    this.classList.toggle('active');
    const response = await storeFront(this.getAttribute('handle'));
    const frame_image = response.data.productByHandle.border_frame_image.reference.image.url
    const title = response.data.productByHandle.title
    const media_images = response.data.productByHandle.media.nodes
    const sliderItems =  media_images.map((item) => { return ` <li id="" class="scroll-snap-start flex flex-center"> <img alt="Image on frame" loading="lazy" class="object-contain h-full" src="${item.image.url}" >` }).join("")
    const slik_Slider = `${sliderItems}`;
    const slider_slector = document.querySelector('div#synapse-photoswipe .synapse-slider-products_images')
    if(document.querySelector('.main_container_section .border_frame_img img')){
      document.querySelector('.main_container_section .border_frame_img img').setAttribute('src',frame_image)
    }    
    document.querySelector('.Modal_popup h2.synapse-modal-title').innerText = title
    slider_slector.innerHTML = ''
    slider_slector.classList.remove('slick-initialized', 'slick-slider');
    slider_slector.innerHTML = slik_Slider
    first_slider()
    $('.synapse-slider-products_images').slick('refresh');
     
})
})





function addToCart() {
const formElement = document.querySelector('product-form.product-form');
const config = fetchConfig('javascript');
config.headers['X-Requested-With'] = 'XMLHttpRequest';
config.headers['Content-Type'] = 'application/json';
const formData = new FormData(formElement.form);
if (formElement.cart) {
  const sections = formElement.cart.getSectionsToRender().map(section => section.id);
  formData.append('sections', sections);
  formData.append('sections_url', window.location.pathname);
  formElement.cart.setActiveElement(document.activeElement);
}
const variants = [];
let idd = parseInt(document.querySelector('input.product-variant-id').value)
variants.push({ id: idd, quantity: 1 })
let activeItem = document.querySelector('ul.collection_frames li.active');
let Frameid = activeItem ? parseInt(activeItem.getAttribute('data-id')) : null;
var FrameObject =  { id: Frameid, quantity: 1 }
if(Frameid){variants.push(FrameObject)}
document.querySelectorAll('.upsell_products .accessory-framing-service input').forEach(item => {
    if (item.checked) {
        var newdds =  { id: parseInt(item.value), quantity: 1 }
        variants.push(newdds)
    }
});  
const bodyData = {
  items: variants,
  sections: formData.get('sections') || [],
  sections_url: window.location.pathname
};
console.log(variants,'variants')
// return
config.body = JSON.stringify(bodyData);
fetch('/cart/add.js', config)
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'product-form',
        errors: response.errors || response.description,
        message: response.message,
      });
      formElement.handleErrorMessage(response.description);
      const soldOutMessage = formElement.submitButton.querySelector('.sold-out-message');
      if (!soldOutMessage) return;
      formElement.submitButton.setAttribute('aria-disabled', true);
      formElement.submitButtonText.classList.add('hidden');
      soldOutMessage.classList.remove('hidden');
      formElement.error = true;
      return;
    } else if (!formElement.cart) {
      window.location = window.routes.cart_url;
      return;
    }
    if (!formElement.error) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        cartData: response,
      });
    }
    formElement.error = false;
    const quickAddModal = formElement.closest('quick-add-modal');
    if (quickAddModal) {
      document.body.addEventListener('modalClosed', () => {
        setTimeout(() => {
          formElement.cart.renderContents(response);
        });
      }, { once: true });
      quickAddModal.hide(true);
    } else {
      formElement.cart.renderContents(response);
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {    
    // formElement.submitButton.classList.remove('loading');
    if (formElement.cart && formElement.cart.classList.contains('is-empty')) formElement.cart.classList.remove('is-empty');
    // if (!formElement.error) formElement.submitButton.removeAttribute('aria-disabled');
     document.querySelector('.product_popup_main').classList.remove('active-popup');
    document.querySelector('body').classList.remove('cart-popup-open');
    
  });
}
const add_selector = document.querySelector('.main_container_section button.add_cart_btn_frame')
if(add_selector){
 add_selector.addEventListener('click',function (e) {
      addToCart()
    }) 
}   

